module.exports = __webpack_public_path__ + "img/youtube.63a3f51a.png";